import React, { ReactNode, useRef, useMemo, MutableRefObject } from "react";
import { Popup, SemanticShorthandItem, PopupContentProps, PopupProps } from "semantic-ui-react";

type PopupBottomLeftProps = {
  trigger?: ReactNode;
  content?: SemanticShorthandItem<PopupContentProps>;
  // classNameZoom: string | string[];
  on?: "focus" | "hover" | "click" | ("focus" | "hover" | "click")[] | undefined;
  hideOnScroll?: boolean;
};

const isZoomAffectingBoundingClientRect = () => {
  const div = document.createElement("div");

  // กำหนด style ให้ div มีขนาด 100x100 และซ่อนไว้
  div.style.cssText = "width:100px;height:100px;position:absolute;left:0;top:0;visibility:hidden";
  document.body.append(div);

  const initialWidth = div.getBoundingClientRect().width;

  document.body.style.zoom = "1.5";

  const zoomedWidth = div.getBoundingClientRect().width;

  document.body.style.zoom = "1";
  div.remove();

  // ถ้าความกว้างเปลี่ยนไปมากกว่า 1px ถือว่า zoom มีผล
  return Math.abs(initialWidth - zoomedWidth) > 1;
};

const calculateCumulativeParentZoom = (target: HTMLDivElement) => {
  let totalZoom = 1;
  let element = target.parentElement;

  // วนลูปผ่าน parent elements จนถึง root
  while (element && element !== document.documentElement) {
    const style = getComputedStyle(element);

    // คำนวณ zoom จาก CSS zoom property
    totalZoom *= Number.parseFloat(style.zoom) || 1;

    // ตรวจสอบและคำนวณ zoom จาก CSS transform
    if (style.transform !== "none") {
      const matrix = new DOMMatrix(style.transform);

      // ใช้ค่า scale จาก transform matrix
      totalZoom *= Math.hypot(matrix.a, matrix.b);
    }

    element = element.parentElement;
  }

  return totalZoom;
};

const PopupBottomLeft: React.FunctionComponent<PopupBottomLeftProps> = (props) => {
  const respiratoryPopupRef = useRef() as MutableRefObject<any>;

  const uid = useMemo(() => {
    return Date.now().toString(36) + Math.random().toString(36).substring(2);
  }, []);

  const handleOpen = (d: PopupProps) => {
    const popup = document.querySelector(`.${d.className || ""}`) as HTMLDivElement | null;
    const triggerElement = respiratoryPopupRef.current?.triggerRef.current;

    if (!(popup && triggerElement)) {
      console.warn("Popup or trigger element not found");

      return;
    }

    const rect = triggerElement.getBoundingClientRect();
    const { x, y, width, height } = rect;

    const isZoomAffecting = isZoomAffectingBoundingClientRect();
    const zoom = isZoomAffecting ? 1 : calculateCumulativeParentZoom(triggerElement);
    const centerY = y * zoom + height * zoom;

    let centerX = x * zoom;

    const popupWidth = popup.offsetWidth;
    const windowWidth = window.innerWidth;

    if (centerX + popupWidth > windowWidth) {
      popup.classList.remove("left");
      popup.classList.add("right");
      const popupContentWidth = (popup.firstElementChild as HTMLDivElement)?.offsetWidth || 0;

      centerX -= popupContentWidth - width * zoom;
    }

    const popupParent = popup.parentElement;

    if (popupParent) {
      popupParent.style.transform = `translate(${centerX}px, ${window.scrollY + centerY}px)`;
      popup.style.opacity = "1";
    }
  };

  return (
    <Popup
      ref={respiratoryPopupRef}
      className={`respiratory-popup-${uid}`}
      style={{ opacity: 0 }}
      pinned
      position="bottom left"
      hideOnScroll={props.hideOnScroll}
      onOpen={(e, d) => {
        if (props.content) {
          setTimeout(() => {
            handleOpen(d);
          });
        }
      }}
      on={props.on}
      content={props.content}
      trigger={props.trigger}
    />
  );
};

export default PopupBottomLeft;
